const loadedComponents = [];
let componentsConfig = {};

const init = (selector, path) => {
	let bodyDataset = document.querySelector(`body`).dataset.adtJsComponents;

	if (
		Object.keys(componentsConfig).length === 0 && typeof bodyDataset !== 'undefined'
	) {
		componentsConfig = JSON.parse(bodyDataset);
	}

	$.nette.ext('live').after(function($el) {
		if (!document.querySelector(`[data-${selector}]`)) return;

		loadedComponents.push('./run.js');

		if (path.includes('/')) {
			import('./run.js').then(component => {
				component.default.run(componentsConfig[selector] || {});
			});

		} else {
			import('./run.js').then(component => {
				component.default.run(componentsConfig[selector] || {});
			});
		}
	});
};

const initSelect2 = () => {
	init('s2', './run.js');
};

const getFirstDiffCharIndex = (a, b) => {
	const longerLength = Math.max(a.length, b.length);
	for (let i = 0; i < longerLength; i++) {
		if (a[i] !== b[i]) return i;
	}
	return -1;
}

export const loadScssModule = (styles) => {
	const newStyles = {};
	for (let [key, value] of Object.entries(styles)) {
		const firstDiffCharIndex = getFirstDiffCharIndex(key, value);
		let newKey = value.slice(0, value.slice.length - 16).slice(2 * firstDiffCharIndex);
		newStyles[newKey] = key;
	}
	return newStyles;
}

export default {
	init,
	initSelect2,
	loadScssModule
}
